import React from "react";
import { MdOutlineFacebook, MdOutlineWhatsapp } from "react-icons/md";
import { LuInstagram } from "react-icons/lu";
import { BsTwitter, BsYoutube, BsTiktok, BsSnapchat } from "react-icons/bs";
import { SlSocialLinkedin } from "react-icons/sl";

const SocialMediaIcons = ({ socialMediaData, merchantTheme, customColor }) => {
  // If no social media data, return null
  if (!socialMediaData) return <div></div>;

  // Parse social media data if it's a string
  let parsedData = socialMediaData;
  if (typeof socialMediaData === "string") {
    parsedData = JSON.parse(socialMediaData);
  }

  // Map of social media platforms to their icons and link keys
  const socialMediaPlatforms = [
    { key: "facebook", icon: <MdOutlineFacebook />, label: "Facebook" },
    { key: "instagram", icon: <LuInstagram />, label: "Instagram" },
    { key: "linkedIn", icon: <SlSocialLinkedin />, label: "LinkedIn" },
    { key: "twitter", icon: <BsTwitter />, label: "Twitter" },
    { key: "whatsapp", icon: <MdOutlineWhatsapp />, label: "WhatsApp" },
    { key: "youtube", icon: <BsYoutube />, label: "YouTube" },
    { key: "tiktok", icon: <BsTiktok />, label: "TikTok" },
    { key: "snapchat", icon: <BsSnapchat />, label: "Snapchat" },
  ];

  // Filter out platforms with empty URLs
  const validPlatforms = socialMediaPlatforms.filter(
    (platform) =>
      parsedData[platform.key] && parsedData[platform.key].trim() !== ""
  );

  // If no valid platforms, return null
  if (validPlatforms.length === 0) return <div></div>;

  return (
    <div className="mt-8 pt-6 border-t border-gray-200">
      <div className="flex flex-col items-center">
        <p
          className={
            customColor ? "text-sm mb-4" : "text-gray-600 text-sm mb-4"
          }
          style={{ color: customColor ? customColor : "" }}
        >
          Follow us on social media
        </p>
        <div className="flex justify-center space-x-4">
          {validPlatforms.map((platform) => {
            const url = parsedData[platform.key];
            return (
              <a
                key={platform.key}
                href={url}
                target="_blank"
                rel="noopener noreferrer"
                className="text-gray-600 hover:text-brandBlue transition-colors hover:scale-110 cursor-pointer"
                style={{ color: merchantTheme?.theme }}
                aria-label={platform.label}
              >
                {platform.icon}
              </a>
            );
          })}
        </div>
      </div>
    </div>
  );
};

export { SocialMediaIcons };
